import React, { useEffect, useState } from 'react';
import Residential from './Residential';
import Commercial from './Commercial';
import LoadingDots from './LoadingDots';
import bot from '../images/happy.png';
import you from '../images/boy.png';

const ProjectHighlights = ({ siteId }) => {
  const [time] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [showFrame, setShowFrame] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  const handleShowFrame = () => {
    setShowFrame(true);
  };

  const projectHighlights = (id) => {
    switch (id) {
      case 1:
        return (
          <div className="frame1">
            <strong>Akaay Infra: Project 1 Highlights</strong>
            <ul>
              <li>HMDA Approved</li>
              <li>Lake-centered Villas</li>
              <li>Boating available at the Lake</li>
              <li>Triplex Villas with Spanish Elevations</li>
              <li>70 Acres with exquisite Landscaping</li>
              <li>Spacious Floor Plans</li>
              <li>Massive Clubhouse</li>
              <li>Indoor & Outdoor Amenities</li>
              <li>Supermarket</li>
              <li>Amphitheatre</li>
              <li>100% Vaastu Compliant</li>
            </ul>
          </div>
        );
      case 2:
        return (
          <div className="frame1">
            <strong>Akaay Infra: Project 2 Highlights</strong>
            <ul>
              <li>Gated Community</li>
              <li>Underground Drainage</li>
              <li>40' Wide Roads</li>
              <li>Street Lights</li>
              <li>Children's Play Area</li>
              <li>Nearby Schools & Hospitals</li>
            </ul>
          </div>
        );
      case 3:
        return (
          <div className="frame1">
            <strong>Akaay Infra: Project 3 Highlights</strong>
            <ul>
              <li>DTCP Approved</li>
              <li>Close to ORR</li>
              <li>Open Gym</li>
              <li>Walking Track</li>
              <li>Greenery Around</li>
            </ul>
          </div>
        );
      case 4:
        return (
          <div className="frame1">
            <strong>Akaay Infra: Project 4 Highlights</strong>
            <ul>
              <li>Farm Plot Venture</li>
              <li>Red Sandalwood Trees</li>
              <li>Fruit Plantation</li>
              <li>10-Year Maintenance by Company</li>
              <li>60% Profit Sharing with Buyers</li>
            </ul>
          </div>
        );
      default:
        return (
          <div className="frame1">
            <strong>Akaay Infra:</strong>
            <div>No amenities found for this site.</div>
          </div>
        );
    }
  };

  return (
    <div>
      <div className="you-time">
        <img src={you} alt="boy" className="boy" />
        You {time.toLocaleTimeString()}
      </div>

      <div className="you-message">
        <div className="frame2">Project Highlights</div>
      </div>

      <div className="chatbot">
        <img src={bot} alt="bot" className="bot" />
        <div className="chatbot-time">{time.toLocaleTimeString()}</div>
      </div>

      {loading ? (
        <div className="frame1">
          <LoadingDots />
        </div>
      ) : (
        <>
        {projectHighlights(siteId)}
        <div className="frame1">
        It's nice to interact with you. How do you want to take it forward?<br></br>
        <div style={{textAlign: 'center'}}>
        <button className="details-button1" style={{ width: '45%', fontSize: '13px' }}  onClick={handleShowFrame}>
          Return to previous menu
        </button>
        </div>
      </div>
      </>
      )}

     

      {showFrame && ( (siteId === 1 || siteId === 2) ? (
        <Residential />
      ) : (
        <Commercial />
      ))}
    </div>
  );
};

export default ProjectHighlights;
